import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import useAuth from "../../contexts/UserContext.tsx";
import Navbar from "../navbar/Navbar";
import Sidebar from "../sidebar/Sidebar";
import "./privatelayout.scss";

const PrivateLayout = () => {
  const { user } = useAuth();
  if (!user) {
    return <Navigate to="/login" />;
  }
  return (
    <div className="mainLayout">
      <Navbar />
      <div className="subLayout">
        <Sidebar />
        <div className="content">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default PrivateLayout;
